import Webapi from './webapi'
import auth from '../auth'

const contentType = 'application/json'

const webapi = () =>
    new Webapi()
        .authorization(auth.get())
        .accept(contentType)
        .contentType(contentType)
        .path('pallets')

export const fetchPalletParcels = (palletId) =>
    webapi()
        .path(palletId)
        .path('parcels')
        .get()
